import { memo } from "react";
import { styled } from "@mui/material";
import Div from "components/primitives/Div";
import type { DivProps } from "components/primitives/Div";
import { useDialogContext } from "./Dialog";

const DialogHeader = styled((props: DivProps) => {
  const { children, ...rest } = props;
  const dialogContext = useDialogContext();
  return (
    <Div data-size={dialogContext.size} {...rest}>
      {children}
    </Div>
  );
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.primary.main,
  gap: theme.spacing(0.5),

  "&[data-size=sm]": {
    minHeight: "40px",
    padding: theme.spacing(1.25, 6, 1.25, 2), // gives space for the close button
  },
  "&[data-size=md]": {
    minHeight: "56px",
    padding: theme.spacing(2, 6, 2, 3), // gives space for the close button
  },
  "&[data-size=lg]": {
    minHeight: "80px",
    padding: theme.spacing(3.125, 8, 3.125, 3), // gives space for the close button
  },
}));

export default memo(DialogHeader);
